import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import PropTypes from 'prop-types';
import $ from 'jquery';
import select2 from 'select2';
import Helper from '../lib/Helper';
import co from '../lib/Co';
import styled from 'styled-components';

class BaseAutoComplete extends React.Component {

  static defaultProps = {
    placeholder: ' ',
    allowCustomValue: false,
  }

  createSearch = (items) => {
    return (searchTerm) => {
      if (!searchTerm || (searchTerm === '') || (searchTerm === '*')) {
        return items.map(el => el);
      }
      var re = new RegExp(searchTerm, 'i');
      if (items) {
        var results = items.filter(el => {
          const Name = el.Name || el.name;
          const Code = el.Code || el.code;
          return (re.test(Name) || re.test(Code));
        });
      }
      if (results.length > 0) {
        return results;
      }
      return [];
    };
  }

  getResult = item => {
      const Id = item.Id || item.id;
      const Code = item.Code || item.code;
      const Name = item.Name || item.name;
      const Count = item.Count || item.count;
      const Image = item.Image || item.image;
  
      const obj = {
        id: (Id || Id === 0) ? Id : Code,
        code: Code,
        text: Name,//Code ? Code + ' - ' + Name : Name,
        count: (Count && (Count !== -1)) ? Count : -1,
        result: item
      }
      if (item.Image) {
        obj.image = Image;
      }
    
      return obj;
  }

  searcher = (fn) => {
    var d = (q) => {
      co(this, function* () {
        let searchResults = []; 
               
        try {
          if (fn) {
            searchResults = yield fn(q.term);
          }
        }
        catch (err) {
          searchResults = [];
        }
  
        if (!searchResults) {
          searchResults = [];
        }
        searchResults = searchResults.map(item => this.getResult(item));

        if(this.props.multiple){
          var rootNode = $(ReactDOM.findDOMNode(this));
          var testData = rootNode.select2('data') || [];
          var refinedSearchResults = [];
          searchResults.map(sr => {
            if(!testData.find(td => td.id == sr.id)){
              refinedSearchResults.push(sr);
            }
          });
          searchResults = refinedSearchResults;
        }

        q.callback({results: searchResults});
        if (q.element.parent().children('.select2-container-active').length === 0) {
          if (searchResults && (searchResults.length > 0) && this.props.bind) {
            if(!this.props.multiple){
              q.element.select2('data', searchResults[0]);
            }
            this.setBindingFromControl();
          }
        }
      });
    };
    return Helper.throttle(200, d, false);
  }

  componentDidMount = () => {
    var self = this;
    var rootNode = $(ReactDOM.findDOMNode(self));
    const search = self.props.data ? this.createSearch(self.props.data) : self.props.search;
    this.search = this.searcher.call(this, search);

    var select2Options = {
      query: (q) => {
        self.search(q);
      },

      dropdownCssClass: 'bigdrop'
    };

    if (this.props.minimumInputLength) {
      select2Options.minimumInputLength = this.props.minimumInputLength;
    }

    if (this.props.multiple) {
      select2Options.multiple = 'multiple';
      select2Options.closeOnSelect = false;
    }

    if (this.props.multiple && this.props.maximumSelectionSize) {
      select2Options.maximumSelectionSize = this.props.maximumSelectionSize;
    }

    if (this.props.addHandler && this.props.allowCustomValue) {
      select2Options.maximumInputLength = this.props.maximumInputLength ? this.props.maximumInputLength : 50;
      select2Options.formatNoMatches = (s) => {
        var message = <div>could not find {s}. <button id='btn-add' className='btn btn-xs btn-labeled btn-success pull-right'><span className='btn-label icon fa fa-plus'></span>Add</button></div>;
        var self = this;
        setTimeout(function () {
          $('#btn-add').click(function (evt) {
            rootNode.select2('close');
            self.props.addHandler(evt, s);
          });
        }, 0);
        return ReactDOMServer.renderToString(message);
      };
    }

    select2Options.allowClear = (this.props.allowClear === undefined)
      ? true
      : this.props.allowClear;

    if (this.props.formatResult) {
      // format for dropdown
      select2Options.formatResult = function (item) {
        var result = self.props.formatResult(item);
        return ReactDOMServer.renderToString(result);
      };
    }

    if (this.props.formatSelection) {
      // format once selected
      select2Options.formatSelection = function (item) {
        var result = self.props.formatSelection(item);
        return ReactDOMServer.renderToString(result);
      };
    }

    if (self.props.minimumResultsForSearch) {
      select2Options.minimumResultsForSearch = self.props.minimumResultsForSearch;
    }

    rootNode.select2(select2Options);

    this.setControlFromBinding();
    rootNode.data().select2.container.find('.select2-focusser').off('keydown');

    rootNode.on('change', (evt) => {
      evt.preventDefault();
      self.setBindingFromControl();
      if (this.props.onChange) {
        this.props.onChange(evt);
      }
    });

    if (this.props.focus) {
      setTimeout(function () {
        rootNode.select2('focus');
      }, 0);
    }
  }

  setBindingFromControl = () => {
    try {
      if (!this.props.bind) {
        return;
      }

      var rootNode = $(ReactDOM.findDOMNode(this));
      if (!rootNode) {
        return;
      }
      var data = rootNode.select2('data');
      if (this.props.multiple) {
        const results = data.map(r => r.result);
        this.props.bind(results.length ? results : null);
      }
      else {
        var result = (data && data.result);
        this.props.bind(result);
      }
    }
    catch (error) {
      return;
    }
  }

  setControlFromBinding = () => { 
    try{
      const rootNode = $(ReactDOM.findDOMNode(this));
      if (!rootNode) {
        return;
      }
        
      rootNode.select2('enable', this.props.enabled);
      rootNode.select2('readonly', this.props.readOnly);
      if (this.props.multiple) {
        const items = this.props.bind ? this.props.bind() : this.props.defaultValue ? this.props.defaultValue : [];
        const data = items.map(item => this.getResult(item));
        rootNode.select2('data', data.length ? data : null);
      }
      else {
        const item = this.props.bind ? this.props.bind() : this.props.defaultValue;
        const Id = item ? (item.Id || item.id) : '';
        var data = (item && Id !== '') ? this.getResult(item) : null;
        rootNode.select2('data', data);
      }
    }
    catch(error){
      return;
    }
  }

  shouldComponentUpdate = (nextProps, nextState) => {
    var shouldUpdate = (!!(this.props.bind && this.props.bind.changed && this.props.bind.changed()) || (this.props.search !== nextProps.search) || (this.props.readOnly !== nextProps.readOnly) || (this.props.enabled !== nextProps.enabled));
    return shouldUpdate;
  }
  
  componentDidUpdate = (prevProps, prevState, snapshot) => {
    if(this.props !== prevProps){
      var self = this;
      if (this.__queued) {
        return;
      }
      
      const search = this.props.data ? this.createSearch( this.props.data) :  this.props.search;
      this.search = this.searcher.call(this, search);
  
      self.__queued = true;
      setTimeout(function () {
        self.setControlFromBinding();
        if (!self.props.multiple) {
          delete self.__queued;
        }
      }, 0);
    }
  }

  render = () => {
    return (
      <input
          {...this.props}
          bind={this.props.bind}
          type='hidden'
          defaultValue={this.props.defaultValue}
          name={this.props.name}
          multiple={this.props.multiple}
        />  
    );
  }

}

BaseAutoComplete.propTypes = {
  search: PropTypes.func,
  data: PropTypes.array
}

const AutoComplete = styled(BaseAutoComplete)`
.select2-choice {
  background-clip: padding-box !important;
  background-color: #FFFFFF;
  background-image: none !important;
  background-repeat: no-repeat !important;
  border:0px  !important;
  border-radius: 0.25rem !important;
  box-shadow: none !important;
  color: #555555 !important;
  display: block !important;
  height: calc(1.5em + 0.75rem + 2px) !important;
  line-height: 29px !important;
  margin-top: 0px !important;
  overflow: hidden !important;
  padding: 0 4px 0 4px!important;
  position: relative !important;
  text-decoration: none !important;
  white-space: nowrap !important;
}

.form-control {
  border: 1px solid #bbb !important;
  border-radius: 2px;
}

.select2-choice .select2-arrow {
  background-image: none !important;
  background-color: #FFFFFF;
  width: 28px !important;
  text-align: center;
  border-left: 1px solid #aaa !important;
}

.select2-choice .select2-arrow b {
  background: none !important;
  display: block;
  height: 100%;
  width: 100%;
  margin-top: 0.280rem;
}

.select2-choice .select2-arrow b:before {
  content: '\f078';
  display: inline;
  font-family: 'Font Awesome 5 Free';
  font-weight: 900;
  text-shadow: none;
}

.select2-dropdown-open.select2-container-active .select2-choice .select2-arrow b:before {
  content: '\f077';
}

 .select2-choices {
  background-clip: padding-box !important;
  background-color: #FFFFFF !important;
  background-image: none !important;
  background-repeat: no-repeat !important;
  border: 0px solid #bbb !important;
  border-radius: 3px !important;
  box-shadow: none !important;
  color: #555555 !important;
  display: block !important;
  height: inherit !important;
  min-height: inherit !important;
  line-height: 29px !important;
  margin-top: 0px !important;
  padding: 0 4px 0 4px!important;
  position: relative !important;
  text-decoration: none !important;
  white-space: nowrap !important;
  overflow: auto;
}

 .select2-choices .select2-search-choice{
  padding: 3px 10px 3px 18px;
  line-height: 17px;
  background-image: none;
  background-color: #FFFFFF;
}  

 .select2-choices .select2-search-field input{
  box-shadow: none !important;
}

.select2-choice abbr {  
  width: 17px !important;
  height: 17px !important;
  top: 10px !important;
  right: 31px !important;  
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAQCAYAAADwMZRfAAARqXpUWHRSYXcgcHJvZmlsZSB0eXBlIGV4aWYAAHjarZpXduQ8k0TfsYpZArxZDhLmnNnBLH9uAiy5ltTfb0otkcViwaSJjEi2Wf/3v9v8D6/kmzUxlZpbzpZXbLH5zkm193WPzsbz9755jrz/dN28rlvPpcAx3Ld5Pfd3rqf3L5T4XJfP100Zzzj1Gci9DXxeQWfW8/ks8hko+HvdPe9Ne77Q84ftPL9+PMM+g399HwvGmInxgjd+BRfs+evvTOH+dn7b+Ru50YXCeTpXQqh/2s+8me4bA+4f7GdfKwvv5rgDvbaVv9jpue7Sl+vhbXr/aUXOP7f49w/01Zx7feUP++09697r7q7HbDBXfjb12uI540bBnOF8LfNT+E2cl/PT+Km224HXJlsVY4U3zXnm3i666brbbp3jcIMlRr984ej98OFcq6H45kdQF0T9cdsXgx9mqPhp4LnAZf+2FnfmbTofk1Vmno47vWMwfPz5x3y98O/+fBpo73GzqR7Xu+tgr/HFMtRz+pe7cIjbj03Tsa8z92C/vtSxAQ+mY+bKBruVO4Qk9x5b4fg52GS4NdqbL67MZwBMxNyJxbiAB2x2IbnsbPG+OIcdK/7prNwT9oIHXDLJT1bpYwgZ51Svc/Od4s69Pvl7GXjBESlkUqVqouCsGFPM5FslhLpJIcWUUk4l1dRSzyHHnHLOJStO9RJKLKnkUkotrfQaaqyp5lpqra325lsAxpJpuZVWW2u9M2mPnbE693cuiJcgUZJkKVKlSR+Ez4gjjTzKqKONPv0MEwgwM88y62yzL7cIpRVXWnmVVVdbfRNrO+y408677Lrb7m9ee7z62WtfPfe719zjNX8cpfeVd69xuZTXEE7hJKnP8JiPDo8X9QAB7dVntroYvXpOfWabDyaE5FllUudMpx7Dg3E5n7Z789275370m8G6/6rf/HeeM+q6/4bnjLrug+f+9Ns3Xpv9wG04DtIsxKYgZCD9uKn72usqbTmmLy0zpk91ueqBpO0pnWQURqA0cF4UKFcJkaROLo1tNsMM/LWsnu3u+o4BP7s6wvksJadH2+au58qqWea922bgUM/INYac9oz5D4aMO88F2tgx16gZ4+Ha3FwY1VCbyd+0MF20Ow3et1ExwmxYvpadV25noOiiHMiqcW/XwxZ21vSTbju5VigF0WNIanLav3+5S0nPiloEQ0TuimysJsIWxLPS3GNlRU5X5J4VSTsbrnGxw7NhoGQxE+ZyeuCzztqWC0a2PRdA9tLPzcuOzMlibRRu+w+HM3e8/3w483F5/8lw5s/d/nvDmZ+M968OZ373xT8ZzvtZRjJluSFr7p3DLDt2IXnrnCvyL2vMTXhVGIW58lsMagR+CUDzKQKf+NPU1ghUKvrblxV0aoYVr+wMYGRbIs+ndCV6QDTh67iiRDPx78NRM7IuNhbbKlWHHQ481ClZUevCbKvsUY49fNwAF0ifLZ8cC7k4Se6txRcwrQI9kTYxMnnLT91jmLbiWKAb2Qr0tzDawoaKM2mJhM3S9wbw0ygbgwdWAQAnQGVTsXfFIqu6SRw1t8LxgvS8bWDHO2XKeJIGYO41Gbu2Plvjw1bxRZ6jF4pHYEhcN+Ho3RtFDC+jy/LMrRicT3QQD3IgwgkL6bMcwABCRygdAHd9cgZLyJgrRjF59JpkjJhGwPqhLgUBmKFbeSNU4jHlp11spanroiUbcRmbe8NwQyaUcGGJ7XHGdtJCsaGOCrf3DF3VZakoqqM07LdHc076WtQiYnCJo07mrVyoTd87b0VmKnjJBqzlFrGcsDge3I6ImjYcExhYaHkQWaVP2la4LXuN9ftJLoB37FBVKhCVmKp3gjZrIFetOGGVAtQKx5THChTTjiuYUoK6QBfOcadGuVBH9JKPxfLULMgkzU7FkWRtOxNy3Z2YL50ymVcnk6Vho7XS9pPhPdZf0ZJtnk2JpjIex+7leHd7O3DoMJGsYWD4BoERSwl5u7EdHuTriSI268gwymYB9Q/rPCCiLhwEMdY6MDIr5j4mizCKAoupWr4kF5nbJuohlaLBTSOLTyNiJrIK8oKKbJrwhKVhg53YG/YM5ENL2HBKvDmWZ+oaMH2opaj8TU75FGjAcVFMuZNGbM3O3hZmghnMPQe1tJKj2AKeNmeFR3UkQ04RI+LWfvJW9eeXI4yt1AE2YEWiT848oonaiScitctQxtcWvoKU1IkbOhm4isRUe5pNIt4YxlWCD15he5mEaaCq17748nKpLTmJEHZQeC37An3lhgjfmW2Njon8hK+Ynqm9kf1Uws6nuOwKU9QvpPbjoPejSI8kQdCkbSQndRlBNsQvsyZDMWId8LexgC+CuMn7gp7lYB9dkCKADho0Cg9YFK4CFYZIgMCkgxRgmYP01NyRfhuHJeGlWETYV8qHjRGcWAB7w1KkM8Uly7G4+dYFbh0lyYxgpU6FlW+cIV/KktpmkFGgmiy7QUHzNJDoUllJTR5Z06tU3adlwSGlC2aQ3X7iamyZQD9Bqts6WZ7kKQzGJSrWOGBFrvR00fEWpVU94TYTGyC3WGhvB7jHxU7bNKVd+YBHvwCWHjEbxZOhMhSYIUUz+tTfMQtwhezupioIUwRZDKy8aYALWdjaItZ2LpQY4r0N5ethalaNsTRU4t12OqvD2LrbdsZfY8lY60LmyIwiRNuM4MvYhRgNi5iTAsJJKZBrvLaJfjmGMe9jfhqSmSldVvljXUkD6aCZ4gNIK2AEyY6biC7QOTUxZcKBSXYFf1a/ADaqN7qgaYEkm4mU8meA/HE0b5Gz9luF/6sfUUhVLb6GUPyJsjlMdnGAfo249h5eUWNXyp3LTbjtUVlaP8kZBNOTxGueJF7zJrF0pOi2SAPQH4+EtAFlK7UCftk33WhwylBchcvUIZqIysu+iRTzU+i0SbgoYIRwE7jOk8AX8kng8JbAO6BNTLhxdi3AvrXHQpE7ceYTCIdyig3VNtFrUvUGtQVxoJagTDvfKcfBoMciaqTPz8DztyPkTvPWQmEQd+QtBRL9tUuFM5C3EXJFctuI4CRv/dS8raxPs3aQqOukxs7tQv98y1vzYnRKWc72vrK6r5TujdBpC+5QukPozGV0FP1l0yUso6PPAE7lZpIZIPcBklBigJ4ibq7U4HXM7vgMRgzmaK/WIfTQfgcS+tm+JgssXMZVY4CZJoq7QOtCmoSj009fhAv6ghYhWpRxZZLalSGXcJF5S+mDcknI1Vd2+83R/O2GL0fl/3h9BKj0UmhfxDCWEoPpII9zo+jHYLMjwKgUanEIAKKbDKxLy/Up1qQ09GqTkNaVI3pvTpomT1I6Na73pGQsNgY3mWpwFkVglhNSAy/ULm1mhvYpDdSh5jeSntDfitaX3CH22/K4VtD/U6ftuZ/C+4Eev5i58pGv3FwZhPYqGrwuedeo0CtnLTaBOlQVunyY2j6Uom1x6LdXxPAqYw6J6RZ6dKXVDUBKABsgsBOfyFIyD4lKgHoCj8b2kkl274Ag4BWcjxpYWrVK+8f+NL84mu27QmASfNP53NjR6PAZ+KcfWucrrIzQVGLUKJAX1LNbR7FZeSm2cgoOdRAZgW4kAFwEW1/ZMzKD9tOFcZKrSdlrP6Z2VaPgFPhNkbEptu+Q/mcfmuNE7Cwnr67SeIiq9r4vS1WOislG/FMKrtoOxzeX5LM1pflK8oP060OCQzAINSI9qs3jH42MqeKg2qadnjbfOORfCtb7MTHsRvWiMC5i56khHM/khtCUKCTfYUP+BGXfaMBDEtIB4csdZ2M5inv5CvdMSVD3aKtPyehvi3jZ9s2yMN4P+fGY9vB/87LrV/7/g22xKGGhcX0tqx3Bqr0Cc5oFpBPEo/Sseo8E6yo/fRnqhwYBQQqwG6hkVT0InNuZdVXOlVtr7ThahAK44CEWhQbHBCUt7BMamsHfZucMwaaWFDyC9jer8uegTcfPzP+feQ3xhACoMyD2t2wJYY2SIcfFQczmNO8byxnq5E4XZOC9bB/KEO1ltFtbAypwgPkTakU08ATfk1VGyx31qsCjovNuniIpvjtOCtLqbSew9wQ9H0HtxvBX1O84LzE1Sh3lvxAC5l0D/i0EUoEyTE8Ng7037QHbiuho8G1pCRt1qYn6127nIMX+G/Bi9dMW+aOlYD72FCQcdpc6UCwQZae/GXcoWyINOCShomhAoUpVjq0XSzH1X6Mzn44QuuFkeQu9MtBo7xPrzBT73hys6ZTunBfRRxjf/q+24H4Q6pECE5K5jNZlOFBmtan7hL6CbaDi2ErH/Npkw6xwj04YQDbJCSWE+OPCMimwze7wTeGWb4jk37pcHwuo+bWCavMloDAnlLkXggMlGLP4cRJRH+LBeSFzVHKYv4fk/0K0dHKlf2TDOPRvamNg3wbM8iCfis5iIBuJs730WQKvoRKGSqZdeO+zPhFJDZKZyEKyT9IPisz8Rar9fgyIlUN26jAS1/QCeSmqeB10VynBhLf0HqmoLCYrm7qaRPuGlxC2rY2TDdoTz9xrkK5n7Dm060PGeTS7tDqChSSGRHkNJemcdegzFH2e+iJXH7mVecjVR1wmayA6CJNSaoBuCcihqhJQK2/CL+bxUn6Jyp3NrbAe32jBkpkftXq4+Ojl1n+tiJ0gBEzkliZUKVmpDYc1QN1slOwcooMgaJOpZYPMq3htKpBMmOdU079hsfkIYRcgqB0n8MkHLYiqr/Op8enIIBR1VgXhPLJtEoMdEb2zie+qF9B4170TzZs6+lQ53GG1rgVNkr7l6UoEhkd33qWYf1JAJpxKW1gqm0uHQ6A+N3ryWDeDHVvbh7vib3AP928qo5Z1gUfCxq+bg5bGqk0C9anquNc0nzoU5nOLQvajjF+6+Kpi1cTaOsBSP0Gd+XIBulhSJPNTl9Rgd8BUg7zP5uqyIG5IflSiwCl91OYdXEXrtEnLuX47eFDK3g+R0iV2p4JJm9G/6usVbtoZzy2CDHuJ1uFb84BJxiIT9ZVCO71GJUq3G9JaH08T6LQalZbvZTzKc9xs82EEEqC9unsAigfZn+4eXh+5jtPcg2P4AZIRVhgDsWTF/NDGXGSo/ccEg3Ayb6laNRupkmSr9YqzyzMisJp6xmg9ZBhJsLVVCgFA8YUqm+/QutnTJO5P5zsqoz1/KT3gJ8VxpKZ0vSxMHDHyEJI2YFttO8ftmz7TqANA03Z4RX77Nzj/BsyJ7jfINH/0MoLfLoM7IQlUTctfyfr8WdDVzmG7jsL22r51UfkCKcmykFn5mF0Vvtr8RNTUoMHmSncobV6fYEaVXTff4j3CIToVu6pd0bRNnxHnPCeCZyG9hNxA9ijVSbF8p5zOIx808GTtWc0TuJeBIAKLYO6W2LCnMgfyNUl6nheXS178g9T+4S6Zkd7Cz04CEkAnQvGnUicFyED5h0MUi1U6jEKKP1yi9Na1dbR9/+aJkjmyFbL1W7gxN+IubooWShMblJaHlNh8dI7qXVpfaFrtzJAUCvCHiSF83U1Qp07XPg0srO/zcFGrhCIwVeJ0mtAh+xOMfHmm8P0jhZ8f01Gymz6UJDWh9Vb08VfOJ2opuA5yQV1b2gweSIfCiNeRGf/n/fTfoyuX1kDEmzYpmL4gtxY2pWCxlqD8uwCnYWRtSVXoTEBOoL499NujCXFeddrZX8a1F6gV9zxXuxQcFa2e6vO9WnWSjRGhL4JIWrZCG3ZfmayapoP34A0bsnGtsop2e5Y+BEt8NUG0j75uV7BiZBVE0AFFz1JevQZ9mHnaDXz7thsqGqItjbcOEma1Glwi5UHxBbYlEK8OjyT3pfr+0KrXyCZhoFg1R4CiHcFVpz4So5pD7eNgY+OwApRtv3oNTnkadSeOFJ8GQN5Pr5KN1cN2gfuizT6gbi39XyGZjUtBQpABcyyz9clXqapN4NlUd+giWwwuX+KLh6E16KoPaUu1PYHeZ+j6dJNBvRkwBOWpFPvtF2pMnDITu3pMGdT8udXxudFhPnU6tLx6z7x9FNc955Uv9H7+n98hY+tzQVWhi8f+H5RyEAbexGfCAAABhWlDQ1BJQ0MgcHJvZmlsZQAAeJx9kT1Iw0AcxV/TSlUqDnYQdchQnSyKijhKFYtgobQVWnUwufRDaNKQpLg4Cq4FBz8Wqw4uzro6uAqC4AeIk6OToouU+L+k0CLGg+N+vLv3uHsHCPUyU83AOKBqlpGKx8RsbkUMvqILAYQwiDGJmXoivZCB5/i6h4+vd1Ge5X3uz9Gj5E0G+ETiWaYbFvE68fSmpXPeJw6zkqQQnxOPGnRB4keuyy6/cS46LPDMsJFJzRGHicViG8ttzEqGSjxFHFFUjfKFrMsK5y3OarnKmvfkLwzlteU012kOIY5FJJCECBlVbKAMC1FaNVJMpGg/5uEfcPxJcsnk2gAjxzwqUCE5fvA/+N2tWZiccJNCMaDjxbY/hoHgLtCo2fb3sW03TgD/M3CltfyVOjDzSXqtpUWOgN5t4OK6pcl7wOUO0P+kS4bkSH6aQqEAvJ/RN+WAvluge9XtrbmP0wcgQ10t3QAHh8BIkbLXPN7d2d7bv2ea/f0AgU1yrQkdfLoAAAAGYktHRAD/AP8A/6C9p5MAAAAJcEhZcwAALiMAAC4jAXilP3YAAAAHdElNRQfkCQQMHSwH3f+JAAAAiklEQVQ4y62T2w3AIAhFr65i97JjMAJjyF51l/7YxjaAmsiPEcjJ5QXsNmYuzFxWc0IfBJDbV4jo1ABaTlCC0EBeTnSU50e2ARiW01sFkBT/t5wJELxSw6B5Q4AKaaDLKKES0fF3RkNJMlQkbY+29CROTscc/wtxANJ6IB4ozkhur6wu29LtbLniGwF3ZpBeNTBDAAAAAElFTkSuQmCC) !important;
  &:hover{
    background: url(data:image/png;base64,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) !important;     
  }
}

.select2-search-choice-close{
    top: 5px !important;
}

.select2-search input {
  margin-top: 3px;
} 

.select2-choice .select2-chosen{
  margin-top: 0.280rem;
}
`;

export default AutoComplete;